var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DOMcreateElement, DOMcreateFragment } from '../typescript/TSXDomParse';
import NavLink from './NavLink';
import NavTitle from './NavTitle';
import MenuImage from './MenuImage';
import { notNullAndLengthy } from '../typescript/helpers';
export default function NavColumnComponents(_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    var component = _a.component, level = _a.level, isNested = _a.isNested;
    var hasChildren = (_d = ((_c = (_b = component.fields) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c.length) > 0) !== null && _d !== void 0 ? _d : false;
    var isImage = (_e = component.fields) === null || _e === void 0 ? void 0 : _e.image;
    var isStandalone = !(hasChildren && isImage);
    var _level = level;
    if (isNested !== true)
        isNested = false;
    if (isNested || isImage)
        _level += 1;
    var className = "level-" + _level;
    if (isImage)
        className += '-image';
    if (isStandalone)
        className += ' standalone-header';
    className += " " + (isImage ? 'image' : 'nav-link') + "-type-" + ((_h = (_g = (_f = component.sys) === null || _f === void 0 ? void 0 : _f.contentType) === null || _g === void 0 ? void 0 : _g.sys) === null || _h === void 0 ? void 0 : _h.id);
    return (DOMcreateElement("li", { className: className }, isImage ? (DOMcreateElement(DOMcreateFragment, null,
        DOMcreateElement("div", { className: "nav-image-container " + ((_l = (_k = (_j = component.sys) === null || _j === void 0 ? void 0 : _j.contentType) === null || _k === void 0 ? void 0 : _k.sys) === null || _l === void 0 ? void 0 : _l.id) },
            DOMcreateElement("a", __assign({}, (notNullAndLengthy((_m = component.fields) === null || _m === void 0 ? void 0 : _m.linkUrl)
                ? { href: component.fields.linkUrl }
                : {})),
                DOMcreateElement(MenuImage, { className: "nav-image", data: component.fields.image }))),
        notNullAndLengthy((_o = component.fields) === null || _o === void 0 ? void 0 : _o.text) ? (DOMcreateElement("div", { className: "level-3-image-data" },
            DOMcreateElement("span", { className: "nav-image-title" }, (_p = component.fields) === null || _p === void 0 ? void 0 : _p.text),
            ((_q = component.fields) === null || _q === void 0 ? void 0 : _q.linkUrl) ? (DOMcreateElement("a", { className: "nav-image-cta", href: (_r = component.fields) === null || _r === void 0 ? void 0 : _r.linkUrl }, "Read More")) : (''))) : (''))) : ((_u = (_t = (_s = component.fields) === null || _s === void 0 ? void 0 : _s.components) === null || _t === void 0 ? void 0 : _t.length) !== null && _u !== void 0 ? _u : 0) > 0 ? (DOMcreateElement(NavTitle, { title: (_v = component.fields) === null || _v === void 0 ? void 0 : _v.text, url: (_w = component.fields) === null || _w === void 0 ? void 0 : _w.url, level: _level })) : (DOMcreateElement(NavLink, { text: (_x = component.fields) === null || _x === void 0 ? void 0 : _x.text, url: (_y = component.fields) === null || _y === void 0 ? void 0 : _y.url, level: _level }))));
}
